import React from 'react'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import Moment from 'react-moment'

import {
  Cont
} from './styled'

const PanelPOInfo = props => {
  const { 
    valueForm
  } = props

  var po = (valueForm.goodsServiceReceiptPOs&&valueForm.goodsServiceReceiptPOs.length)?valueForm.goodsServiceReceiptPOs[0]:null

  return (
    <React.Fragment>
    {!po?null:
      <div style={{maxWidth:'100%'}}>
        <Cont>
          <div className='title'>
            PO Information
          </div>
          {/* Company Address */}
          <div className='rowI'>
            <div className='stBold'>{po.companyName||po.companyNameEn}</div>
            <div className='stBold'>{`Tax Id : ${po.companyTax}`}</div>
          </div>
          {/* Address */}
          <div>
            {`Address : ${po.companyAddress||po.companyAddressEn}`}
          </div>
          {/* Delivery Address */}
          <div className='stBold'>Delivery Address</div>
          <div>{po.deliveryName||po.deliveryNameEn}</div>
          <div>{po.deliveryAddress||po.deliveryAddressEn}</div>
        </Cont>
      </div>
    }
    </React.Fragment>
  )   

}

const mapStateToProps = (state) => {
  return {
    valueForm: getFormValues('formGR')(state),
  }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(PanelPOInfo)
